module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/lookup-management/programarea/programarea-detail/programarea-detail.component.css
// module id = ./src/app/admin/lookup-management/programarea/programarea-detail/programarea-detail.component.css
// module chunks = main